function ascii(value) {
  return value
    .replace(/ß/giu, 'ss')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/giu, '')
}

function characters(value) {
  return Array.from(value)
}

export function normalizeMeetingSeriesCode(value, maxLength = 5) {
  return characters(String(value).trim().toLocaleUpperCase('de-DE'))
    .slice(0, maxLength)
    .join('')
}

export function suggestMeetingSeriesCode(name) {
  const words = String(name).match(/[\p{L}\p{N}]+/gu) ?? []

  if (words.length === 0) {
    return ''
  }

  if (words.length === 1) {
    return characters(ascii(words[0])).slice(0, 3).join('').toUpperCase()
  }

  return words
    .map(word => characters(ascii(word))[0] ?? '')
    .filter(Boolean)
    .slice(0, 3)
    .join('')
    .toUpperCase()
}

export default function meetingSeriesCode() {
  let nameInput = null
  let nameInputListener = null
  let synchronizing = false

  return {
    manuallyEdited: false,

    init() {
      if (this.$root.dataset.autoSuggest !== 'true') {
        return
      }

      const form = this.$root.closest('form')
      const nameFieldId = this.$root.dataset.nameFieldId
      nameInput = form?.querySelector(`#${CSS.escape(nameFieldId)}`) ?? null

      if (!nameInput) {
        return
      }

      nameInputListener = () => this.nameChanged(nameInput.value)
      nameInput.addEventListener('input', nameInputListener)

      const currentCode = this.$refs.code?.value ?? ''
      const currentSuggestion = suggestMeetingSeriesCode(nameInput.value)
      this.manuallyEdited = currentCode !== '' && currentCode !== currentSuggestion

      if (!this.manuallyEdited && currentCode === '') {
        this.updateCode(currentSuggestion)
      }
    },

    destroy() {
      if (nameInput && nameInputListener) {
        nameInput.removeEventListener('input', nameInputListener)
      }
    },

    nameChanged(name) {
      if (!this.manuallyEdited) {
        this.updateCode(suggestMeetingSeriesCode(name))
      }
    },

    codeChanged(event) {
      if (synchronizing) {
        return
      }

      this.manuallyEdited = true
      const normalized = normalizeMeetingSeriesCode(
        event.target.value,
        Number(this.$root.dataset.maxLength)
      )

      if (normalized !== event.target.value) {
        this.updateCode(normalized)
      }
    },

    updateCode(value) {
      const codeInput = this.$refs.code

      if (!codeInput || codeInput.value === value) {
        return
      }

      synchronizing = true
      codeInput.value = value
      codeInput.dispatchEvent(new Event('input', { bubbles: true }))
      synchronizing = false
    }
  }
}
